<template>
  <div>
    <report-panel :anchor="anchor" v-if="report.includes_hse">
      <div slot="title">
        HSE Cases<br />
        <span style="font-size: 12px; font-weight: 400"
          >Cases on the HSE's public register of convictions in the past 5 years</span
        >
      </div>
      <div slot="body">
        <table class="table table-striped" id="company-hsecases-table" v-if="hsecases.length === 0">
          <tr>
            <td colspan="3" style="text-align: center">
              <h6>No HSE cases found</h6>
              <p>
                Using the search
                <strong>{{ companyname }}</strong>
              </p>
            </td>
          </tr>
        </table>
        <table class="table table-striped" id="company-hsecases-table" v-if="hsecases.length > 0">
          <tr>
            <td colspan="3" style="text-align: center">
              <h6 class="warning-heading">
                {{ hsecases.length }}
                <span v-if="hsecases.length > 1">HSE cases found</span>
                <span v-if="hsecases.length === 1">HSE case found</span>
              </h6>
              <p>
                Using the search
                <strong>{{ companyname }}</strong>
              </p>
            </td>
          </tr>
          <tbody v-for="hsecase in hsecases" :key="hsecase.id">
            <tr style="background-color: #f5d4af">
              <th scope="row">HSE Case Number:</th>
              <td>
                {{ isEmptyMessage(hsecase.case_number) }}
              </td>
              <td>
                <div v-if="hsecase.case_number" class="text-right">
                  <a
                    v-bind:href="
                      'http://www.hse.gov.uk/prosecutions/case/case_details.asp?SV=' +
                      hsecase.case_number
                    "
                    target="_blank"
                    role="button"
                    class="btn btn-viewReport btn-xs"
                    >view case details &gt;</a
                  >
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">Defendant's Name:</th>
              <td colspan="2">{{ isEmptyMessage(hsecase.defendants_name) }}</td>
            </tr>
            <tr>
              <th scope="row">Offence Date:</th>
              <td colspan="2">{{ isEmptyMessage(hsecase.offence_date) }}</td>
            </tr>
            <tr>
              <th scope="row">Local Authority:</th>
              <td colspan="2">{{ isEmptyMessage(hsecase.local_authority) }}</td>
            </tr>
            <tr>
              <th scope="row">Main Activity:</th>
              <td colspan="2">{{ isEmptyMessage(hsecase.main_activity) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report', 'showAnchor', 'hsecases', 'companyname'],
  computed: {
    anchor() {
      if (this.showAnchor) {
        return '#about';
      }
      return '';
    },
  },
};
</script>

<style scoped>
.warning-heading {
  color: #e0741c;
  font-size: 120%;
}
</style>
